import { useCallback } from 'react';
import { DEFAULT_PREFERENCES } from '../DEFAULTS';
import { preferenceActions, usePreferenceStore } from '../store';
import { PreferenceDict, PreferenceKey } from '../types';
import { usePreferenceMutation } from './queries';

export function usePreference<K extends PreferenceKey, D extends boolean = false>(
  id: K,
  omitDefaultValue: D = false as D
): [D extends true ? PreferenceDict[K] | undefined : PreferenceDict[K], (value: PreferenceDict[K]) => void] {
  const mutation = usePreferenceMutation();

  const preferenceData = usePreferenceStore(
    (state) => state.prefs[id],
    (a, b) => a?.updatedAt === b?.updatedAt
  );
  const preferenceValue = preferenceData?.value ?? (!omitDefaultValue ? DEFAULT_PREFERENCES[id] : undefined);
  const setPreference = useCallback(
    (newValue: PreferenceDict[K]) => {
      const updatedAt = new Date().toISOString();

      preferenceActions.setPreference(id, newValue, updatedAt);

      mutation.mutate({
        id,
        value: newValue,
        updatedAt,
      });
    },
    [id, mutation]
  );

  return [preferenceValue, setPreference];
}
